export const REVENUE_SUMMARY_REPORT_FETCHING =
  'REVENUE_SUMMARY_REPORT_FETCHING';
export const REVENUE_SUMMARY_REPORT_FETCH_ERROR =
  'REVENUE_SUMMARY_REPORT_FETCH_ERROR';
export const REVENUE_SUMMARY_REPORT_GET_REPORT =
  'REVENUE_SUMMARY_REPORT_GET_REPORT';
export const REVENUE_SUMMARY_REPORT_GET_REIMBURSEMENT_RATES =
  'REVENUE_SUMMARY_GET_REIMBURSEMENT_RATES';
export const REVENUE_SUMMARY_REPORT_SET_SELECTED_SITES =
  'REVENUE_SUMMARY_REPORT_SET_SELECTED_SITES';



// WEBPACK FOOTER //
// ./src/pages/revenuesummaryreport/state/report/types.js